'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var iconStyles = require('../iconStyles.js');
var SvgIcon = require('../../node_modules/@material-ui/core/esm/SvgIcon/SvgIcon.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var FundboxAppIcon = function FundboxAppIcon(props) {
  return React__default["default"].createElement(SvgIcon["default"], _objectSpread({}, props, {
    x: "0px",
    y: "0px",
    viewBox: "0 0 207 217"
  }), React__default["default"].createElement("g", {
    id: "Fundbox-symbol"
  }, React__default["default"].createElement("g", {
    id: "FBX-symbol",
    transform: "translate(28.000000, 21.000000)"
  }, React__default["default"].createElement("g", null, React__default["default"].createElement("path", {
    fill: "#1CB899",
    d: "M124,116.6v0.2L75.4,146l-48.7-29.2V58.4l0,0L10.9,35.2l-26-1.8c-1.5,2.4-2.3,5.3-2.3,8.2v91.9\n\t\t\t\t\tc0,5.6,2.9,10.9,7.7,13.7l77.4,45.9c2.4,1.4,5,2.1,7.7,2.1c2.6,0,5.3-0.7,7.7-2.1l77.4-45.9c2.3-1.4,4.2-3.3,5.5-5.6l-16.6-24.6\n\t\t\t\t\tL124,116.6z"
  }), React__default["default"].createElement("path", {
    fill: "#47BEA6",
    d: "M160.4,28L83.1-17.9c-4.7-2.8-10.6-2.8-15.4,0L-9.7,28c-2.3,1.3-4.1,3.2-5.4,5.4l41.7,25\n\t\t\t\t\tl48.7-29.2l48.7,29.2v58.2l41.9,25c1.4-2.4,2.2-5.2,2.2-8.1V41.7C168.1,36,165.2,30.8,160.4,28"
  })))));
};

var FundboxAppIcon$1 = iconStyles()(FundboxAppIcon);

module.exports = FundboxAppIcon$1;
